/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BulkPrintRequest } from '../models/bulk-print-request';
import { createBulkPrintRequest } from '../fn/bulk-print/create-bulk-print-request';
import { CreateBulkPrintRequest$Params } from '../fn/bulk-print/create-bulk-print-request';
import { deleteBulkPrintRequest } from '../fn/bulk-print/delete-bulk-print-request';
import { DeleteBulkPrintRequest$Params } from '../fn/bulk-print/delete-bulk-print-request';
import { downloadBulkPrintRequest } from '../fn/bulk-print/download-bulk-print-request';
import { DownloadBulkPrintRequest$Params } from '../fn/bulk-print/download-bulk-print-request';
import { listBulkPrintRequests } from '../fn/bulk-print/list-bulk-print-requests';
import { ListBulkPrintRequests$Params } from '../fn/bulk-print/list-bulk-print-requests';

@Injectable({ providedIn: 'root' })
export class BulkPrintService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `bulkPrintRequestControllerListBulkPrintRequests()` */
  static readonly BulkPrintRequestControllerListBulkPrintRequestsPath = '/bulk-print/program/{programId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listBulkPrintRequests()` instead.
   *
   * This method doesn't expect any request body.
   */
  listBulkPrintRequests$Response(
    params: ListBulkPrintRequests$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<BulkPrintRequest>>> {
    return listBulkPrintRequests(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listBulkPrintRequests$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listBulkPrintRequests(
    params: ListBulkPrintRequests$Params,
    context?: HttpContext
  ): Observable<Array<BulkPrintRequest>> {
    return this.listBulkPrintRequests$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BulkPrintRequest>>): Array<BulkPrintRequest> => r.body)
    );
  }

  /** Path part for operation `bulkPrintRequestControllerCreateBulkPrintRequest()` */
  static readonly BulkPrintRequestControllerCreateBulkPrintRequestPath = '/bulk-print';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createBulkPrintRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBulkPrintRequest$Response(
    params: CreateBulkPrintRequest$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<BulkPrintRequest>> {
    return createBulkPrintRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createBulkPrintRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBulkPrintRequest(params: CreateBulkPrintRequest$Params, context?: HttpContext): Observable<BulkPrintRequest> {
    return this.createBulkPrintRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<BulkPrintRequest>): BulkPrintRequest => r.body)
    );
  }

  /** Path part for operation `bulkPrintRequestControllerDownloadBulkPrintRequest()` */
  static readonly BulkPrintRequestControllerDownloadBulkPrintRequestPath = '/bulk-print/{bulkPrintRequestId}/download';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadBulkPrintRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadBulkPrintRequest$Response(
    params: DownloadBulkPrintRequest$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return downloadBulkPrintRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadBulkPrintRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadBulkPrintRequest(params: DownloadBulkPrintRequest$Params, context?: HttpContext): Observable<string> {
    return this.downloadBulkPrintRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `bulkPrintRequestControllerDeleteBulkPrintRequest()` */
  static readonly BulkPrintRequestControllerDeleteBulkPrintRequestPath = '/bulk-print/{bulkPrintRequestId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteBulkPrintRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBulkPrintRequest$Response(
    params: DeleteBulkPrintRequest$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    return deleteBulkPrintRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteBulkPrintRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBulkPrintRequest(params: DeleteBulkPrintRequest$Params, context?: HttpContext): Observable<void> {
    return this.deleteBulkPrintRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }
}
